import axios from "axios";
import { createContext, useContext, useEffect, useMemo, useState } from "react";

const AuthContext = createContext();

const AuthProvider = ({ children }) => {
  // State to hold the authentication token
  const [token, setToken_] = useState(localStorage.getItem("token"));
  // Bot proxy admin token — only present for users with role='Admin'.
  // Sent on every /api/bot/* request as the x-admin-token header.
  const [adminApiToken, setAdminApiToken_] = useState(
    localStorage.getItem("adminApiToken") || null,
  );

  // Function to set the authentication token
  const setToken = (newToken) => {
    setToken_(newToken);
  };

  const setAdminApiToken = (next) => {
    setAdminApiToken_(next);
  };

  useEffect(() => {
    if (token) {
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;
      localStorage.setItem('token',token);
    } else {
      delete axios.defaults.headers.common["Authorization"];
      localStorage.removeItem('token')
    }
  }, [token]);

  useEffect(() => {
    if (adminApiToken) {
      axios.defaults.headers.common["x-admin-token"] = adminApiToken;
      localStorage.setItem("adminApiToken", adminApiToken);
    } else {
      delete axios.defaults.headers.common["x-admin-token"];
      localStorage.removeItem("adminApiToken");
    }
  }, [adminApiToken]);

  // Memoized value of the authentication context
  const contextValue = useMemo(
    () => ({
      token,
      setToken,
      adminApiToken,
      setAdminApiToken,
    }),
    [token, adminApiToken]
  );

  // Provide the authentication context to the children components
  return (
    <AuthContext.Provider value={contextValue}>{children}</AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};

export default AuthProvider;
